/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMfrmOpenContentViewProps } from './mfrm-open-content';

export default (props: IMfrmOpenContentViewProps) => {
    const htmlContent = props.config.content || '';

    return (
        <div className='mfrm-open-content'>
            {/* tslint:disable-next-line: react-no-dangerous-html */}
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </div>
    );
};
